<div class="due-date">
    <div class="due-date__item">
        <ins-input
            autosize
            rtl="false"
            data-testid="due-date-day-value"
            maxlength="4"
            class="due-date__item due-date__day"
            inputmode="decimal"
            [precision]="0"
            [ngModel]="day"
            (ngModelChange)="onDayChange($event)"
            [sklValidate]="dayValidationKey">
        </ins-input>
        <span
            [sklValidateInner]="{key: dayValidationKey, option: 'disable'}"
            data-testid="due-date-day-label"
            role="text"
            class="due-date__text">
            {{dayText}}
        </span>
    </div>

    <div class="due-date__item due-date__date">
        <span
            [sklValidateInner]="{key: dateValidationKey, option: 'disable'}"
            role="text"
            class="due-date__text">
            &#160;=
        </span>
        <ins-datepicker
            #datepicker
            class="due-date__date"
            data-testid="due-date-date-value"
            [ngModel]="date"
            (ngModelChange)="onDateChange($event)"
            [sklValidate]="dateValidationKey">
        </ins-datepicker>
    </div>
</div>
